import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { TextField } from "@material-ui/core";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            paddingRight: theme.spacing(1)
        },
        highlight:
            theme.palette.type === "light"
                ? {
                      color: theme.palette.secondary.main,
                      backgroundColor: lighten(theme.palette.secondary.light, 0.85)
                  }
                : {
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.secondary.dark
                  },
        spacer: {
            flex: "1 1 100%"
        },
        actions: {
            color: theme.palette.text.secondary
        },
        title: {
            flex: "0 0 auto",
            "& h6": {
                paddingTop: 20
            }
        },
        searchTextField: {
            margin: "0 20px",
            minWidth: 200
        }
    });

const AuthoritiesTableToolbar = ({
    classes,
    numSelected,
    searchValue,
    onSearchValueChange
}: {
    classes: Partial<ClassNameMap<string>>;
    numSelected: number;
    searchValue: string;
    onSearchValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
    return (
        <Toolbar className={`${classes.root}, ${numSelected > 0 ? classes.highlight : ""}`}>
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
                    </Typography>
                ) : (
                    <Typography variant="h6" id="tableTitle">
                        Authorities
                    </Typography>
                )}
            </div>
            <TextField
                label="Search"
                className={classes.searchTextField}
                value={searchValue}
                onChange={onSearchValueChange}
            />
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Tooltip title="Filter list">
                        <IconButton aria-label="Filter list">
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

export default withStyles(styles)(AuthoritiesTableToolbar);
